import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createBillingPeriod,
  deleteBillingPeriod,
  getBillingPeriodList,
  updateBillingPeriod,
} from '../../api/constlink';
import {
  createBillingPeriodAsync,
  CREATE_BILLING_PERIOD,
  deleteBillingPeriodAsync,
  DELETE_BILLING_PERIOD,
  getBillingPeriodListAsync,
  GET_BILLING_PERIOD_LIST,
  updateBillingPeriodAsync,
  UPDATE_BILLING_PERIOD,
} from './actions';
import { BillingPeriod } from './types';

function* getBillingPeriodListSaga(
  action: ReturnType<typeof getBillingPeriodListAsync.request>,
) {
  try {
    const billingPeriods: BillingPeriod[] = yield call(
      getBillingPeriodList,
      action.payload,
    );
    yield put(getBillingPeriodListAsync.success(billingPeriods));
  } catch (e: any) {
    yield put(getBillingPeriodListAsync.failure(e));
  }
}

function* createBillingPeriodSaga(
  action: ReturnType<typeof createBillingPeriodAsync.request>,
) {
  try {
    const billingPeriods: BillingPeriod[] = yield call(
      createBillingPeriod,
      action.payload,
    );
    yield put(createBillingPeriodAsync.success(billingPeriods));
  } catch (e: any) {
    yield put(createBillingPeriodAsync.failure(e));
  }
}

function* updateBillingPeriodSaga(
  action: ReturnType<typeof updateBillingPeriodAsync.request>,
) {
  try {
    const billingPeriod: BillingPeriod = yield call(
      updateBillingPeriod,
      action.payload,
    );
    yield put(updateBillingPeriodAsync.success(billingPeriod));
  } catch (e: any) {
    yield put(updateBillingPeriodAsync.failure(e));
  }
}

function* deleteBillingPeriodSaga(
  action: ReturnType<typeof deleteBillingPeriodAsync.request>,
) {
  try {
    const billingPeriodId: number = yield call(
      deleteBillingPeriod,
      action.payload,
    );
    yield put(deleteBillingPeriodAsync.success(billingPeriodId));
  } catch (e: any) {
    yield put(deleteBillingPeriodAsync.failure(e));
  }
}

export function* billingPeriodsSaga() {
  yield takeLatest(GET_BILLING_PERIOD_LIST, getBillingPeriodListSaga);
  yield takeLatest(CREATE_BILLING_PERIOD, createBillingPeriodSaga);
  yield takeLatest(UPDATE_BILLING_PERIOD, updateBillingPeriodSaga);
  yield takeLatest(DELETE_BILLING_PERIOD, deleteBillingPeriodSaga);
}
